// eslint-disable-next-line import/prefer-default-export
export const Environments = {
    DEV: 'dev',
    TEST: 'test',
    STAGE: 'stage',
    PROD: 'production' // has to match for recaptcha
};
